import { makeStyles } from "@material-ui/styles"
import { MAX_PAGE_WIDTH, CONTENT_WIDTH } from "@styles/themes";

const useStyle = makeStyles((theme) => ({
  scrollableContainer: {
    width: "100%",
    padding: "0 48px",
    "& .vCon:not(:hover) > :first-child .vBut": {
      opacity: 0,
    },
  },
  pageFormat: {
    margin: "4px auto",
    padding: 0,
    borderRadius: 5,
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15) !important",
    width: "calc(100% - 48px)",
    overflow: "hidden",
  },
  scalableContainer: {
    width: CONTENT_WIDTH,
    paddingLeft: 48,
    paddingRight: 48,
    position: "relative",
  },
  proposalBar: {
    marginLeft: -48,
    marginRight: -48,
    width: `calc(100% + ${2 * 48}px) !important`,
  },
  titleContainer: {
    width: "100%",
    paddingTop: 24,
    paddingLeft: 48,
    paddingRight: 48,
    margin: "0 -48px",
    backgroundColor: theme.props.backgroundSecondary,
    boxSizing: "content-box",
  },
  titleBarRoot: {
    "&:not(.pdf-mode):not(.preview-mode):not(.printer-mode)": {
      maxWidth: "100%",
    },
    "&.pdf-mode &.preview-mode": {
      maxWidth: MAX_PAGE_WIDTH,
    },
  },
  titleContainerLast: {
    paddingBottom: 24,
    borderBottom: "1px solid " + theme.props.border,
  },
}));

export default useStyle;
